var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcs2Socket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 97,
    viewBox: "0 0 72 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_20236)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.9586 24.1641C72.2414 18.2795 68.5304 8.28386 59.1079 2.77047C55.0588 0.398745 46.4917 0.426243 46.4917 0.426243H26.6603C15.8789 0.034393 0.593217 3.99414 0 28.8525L0.055183 77.8406C0.055183 88.8605 8.91205 97 20.2384 97H51.6513C62.9776 97 71.9931 87.4513 71.9931 76.0876L71.9517 24.171L71.9586 24.1641Z",
    fill: "#172228"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.5819 90.8129H22.4733C12.2368 90.8129 3.93869 82.5429 3.93869 72.341L4.90439 28.2132C4.90439 13.2817 15.5064 1.49182 29.7505 1.53307L49.4164 1.62931C58.6664 2.64675 68.9994 12.883 68.9994 24.2741V71.4611C68.9994 82.151 60.3081 90.8129 49.5819 90.8129Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9473 22.7892L29.2815 22.7548C15.0374 22.741 4.43533 26.9758 4.43533 32.3379L4.8699 43.9972C4.8699 46.3208 12.6093 50.0399 18.2794 52.4598C20.3625 53.3466 20.6039 56.1583 18.7346 57.4369C13.7544 60.8536 7.09791 63.9403 6.37364 71.0554C5.14581 83.2028 14.4097 90.8198 22.4733 90.8198L45.995 91.9541C54.438 91.9541 61.2876 88.8399 61.2876 85.0039C61.2876 85.0039 73.9797 69.763 55.8935 59.1143C52.5756 57.162 53.0102 53.7453 56.7764 52.9135C62.5499 51.6486 68.5304 49.8543 68.5304 47.8744V30.9286C68.5304 26.8383 58.1974 23.1604 48.9473 22.796V22.7892Z",
    fill: "#31404C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2918 31.238C11.2918 24.8447 13.7957 19.0494 17.8517 14.8491C18.6932 13.976 19.8659 13.5085 21.0661 13.5085H46.7193C47.9057 13.5085 49.0577 13.9623 49.8992 14.8147C54.0586 19.0013 56.9143 24.9753 56.9143 31.4924C56.9143 44.3341 46.3468 54.5015 33.8755 54.5015C21.4041 54.5015 11.2918 44.0866 11.2918 31.2449V31.238Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.1132 27.3814C15.1132 22.3492 16.817 17.7157 19.6865 14.031C21.2524 12.0167 23.6597 10.8206 26.2188 10.8206H47.4712C49.7682 10.8206 51.9962 11.7624 53.4861 13.5085C56.7143 17.2895 58.8389 22.2529 58.8389 27.6151C58.8389 39.6112 48.7128 49.0981 36.7588 49.0981C24.8048 49.0981 15.1132 39.3775 15.1132 27.3814Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3658 33.4172C40.9468 33.4172 43.8498 30.524 43.8498 26.9551C43.8498 23.3862 40.9468 20.493 37.3658 20.493C33.7848 20.493 30.8818 23.3862 30.8818 26.9551C30.8818 30.524 33.7848 33.4172 37.3658 33.4172Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3727 22.1636C40.6285 22.1636 43.3186 24.5353 43.8153 27.6357C43.836 27.4088 43.8498 27.182 43.8498 26.9551C43.8498 23.3872 40.9458 20.493 37.3658 20.493C33.7858 20.493 30.8818 23.3872 30.8818 26.9551C30.8818 27.2026 30.9025 27.4501 30.9301 27.6907C31.406 24.5628 34.11 22.1636 37.3796 22.1636H37.3727Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8887 29.2993L30.7093 27.7182C30.6748 27.4432 30.661 27.1957 30.661 26.9551C30.661 23.2703 33.6685 20.2799 37.3589 20.2799C41.0492 20.2799 44.0567 23.2772 44.0567 26.9551C44.0567 27.182 44.0429 27.4157 44.0153 27.6563L43.8498 29.2512L43.5946 27.6701C43.0979 24.604 40.4767 22.3766 37.3589 22.3766C34.241 22.3766 31.5854 24.6727 31.1163 27.7251L30.8749 29.2993H30.8887ZM37.3589 20.7061C34.1859 20.7061 31.5578 23.0641 31.1439 26.1095C32.1717 23.6553 34.6204 21.9504 37.3727 21.9504C40.1249 21.9504 42.5323 23.5866 43.567 26.0202C43.1117 23.016 40.5043 20.7061 37.3658 20.7061H37.3589Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8013 23.1398C45.9053 26.7008 44.0222 31.8498 39.6697 33.1629C43.4773 31.0868 44.9948 26.9964 42.8013 23.1398Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1238 32.6404C28.5296 29.9525 29.247 22.1773 35.4068 20.7474C29.9092 22.8923 29.3849 29.3544 34.1238 32.6404Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.042 27.6151C39.042 28.5844 38.3039 29.3681 37.3865 29.3681C36.4691 29.3681 35.731 28.5844 35.731 27.6151C35.731 26.6458 36.4691 25.8621 37.3865 25.8621C38.3039 25.8621 39.042 26.6458 39.042 27.6151Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3865 29.5812C36.3587 29.5812 35.5172 28.7012 35.5172 27.615C35.5172 26.5289 36.3518 25.6489 37.3865 25.6489C38.4212 25.6489 39.2558 26.5289 39.2558 27.615C39.2558 28.7012 38.4143 29.5812 37.3865 29.5812ZM37.3865 26.0683C36.5932 26.0683 35.9448 26.7626 35.9448 27.615C35.9448 28.4675 36.5932 29.1618 37.3865 29.1618C38.1797 29.1618 38.8281 28.4675 38.8281 27.615C38.8281 26.7626 38.1797 26.0683 37.3865 26.0683Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.3658 28.6737C38.3182 28.6737 39.0902 27.9043 39.0902 26.9551C39.0902 26.0059 38.3182 25.2365 37.3658 25.2365C36.4134 25.2365 35.6413 26.0059 35.6413 26.9551C35.6413 27.9043 36.4134 28.6737 37.3658 28.6737Z",
    fill: "url(#paint0_linear_6_20236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3597 40.6666C51.9334 37.1438 49.5331 33.8244 45.9983 33.2526C42.4636 32.6807 39.133 35.073 38.5592 38.5958C37.9854 42.1186 40.3858 45.4379 43.9205 46.0098C47.4553 46.5816 50.7859 44.1894 51.3597 40.6666Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9672 34.8334C48.223 34.8334 50.9132 37.2051 51.4098 40.3055C51.4305 40.0786 51.4443 39.8518 51.4443 39.6249C51.4443 36.057 48.5403 33.1628 44.9603 33.1628C41.3803 33.1628 38.4763 36.057 38.4763 39.6249C38.4763 39.8724 38.497 40.1199 38.5246 40.3605C39.0006 37.2326 41.7045 34.8334 44.9741 34.8334H44.9672Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4901 41.976L38.3108 40.388C38.2763 40.113 38.2625 39.8655 38.2625 39.6249C38.2625 35.9401 41.27 32.9497 44.9603 32.9497C48.6507 32.9497 51.6582 35.947 51.6582 39.6249C51.6582 39.8518 51.6444 40.0855 51.6168 40.3261L51.4512 41.921L51.196 40.3399C50.6994 37.2738 48.0782 35.0464 44.9603 35.0464C41.8425 35.0464 39.1868 37.3494 38.7247 40.3949L38.4832 41.9691L38.4901 41.976ZM44.9603 33.3759C41.7873 33.3759 39.1592 35.7339 38.7454 38.7793C39.7731 36.3251 42.2219 34.6202 44.9741 34.6202C47.7264 34.6202 50.1337 36.2564 51.1684 38.69C50.7132 35.6858 48.1058 33.3759 44.9603 33.3759Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3959 35.8164C53.4999 39.3774 51.6168 44.5265 47.2642 45.8395C51.0718 43.7634 52.5894 39.673 50.3959 35.8164Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7183 45.3101C36.1242 42.6221 36.8415 34.847 43.0013 33.4171C37.5037 35.562 36.9795 42.0241 41.7183 45.3101Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6365 40.2917C46.6365 41.261 45.8985 42.0447 44.981 42.0447C44.0636 42.0447 43.3255 41.261 43.3255 40.2917C43.3255 39.3224 44.0636 38.5387 44.981 38.5387C45.8985 38.5387 46.6365 39.3224 46.6365 40.2917Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.981 42.2578C43.9532 42.2578 43.1117 41.3779 43.1117 40.2917C43.1117 39.2055 43.9464 38.3256 44.981 38.3256C46.0157 38.3256 46.8504 39.2055 46.8504 40.2917C46.8504 41.3779 46.0088 42.2578 44.981 42.2578ZM44.981 38.7449C44.1878 38.7449 43.5394 39.4392 43.5394 40.2917C43.5394 41.1441 44.1878 41.8316 44.981 41.8316C45.7743 41.8316 46.4227 41.1373 46.4227 40.2917C46.4227 39.4461 45.7743 38.7449 44.981 38.7449Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.2359 39.6317C43.2359 38.683 44.0084 37.9131 44.9603 37.9131C45.9122 37.9131 46.6848 38.683 46.6848 39.6317C46.6848 40.5804 45.9122 41.3504 44.9603 41.3504C44.0084 41.3504 43.2359 40.5804 43.2359 39.6317Z",
    fill: "url(#paint1_linear_6_20236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9686 32.7505C55.5496 32.7505 58.4526 29.8573 58.4526 26.2884C58.4526 22.7195 55.5496 19.8263 51.9686 19.8263C48.3876 19.8263 45.4846 22.7195 45.4846 26.2884C45.4846 29.8573 48.3876 32.7505 51.9686 32.7505Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9755 21.4899C55.2313 21.4899 57.9214 23.8616 58.4181 26.962C58.4388 26.7351 58.4526 26.5083 58.4526 26.2814C58.4526 22.7135 55.5486 19.8193 51.9686 19.8193C48.3886 19.8193 45.4846 22.7135 45.4846 26.2814C45.4846 26.5289 45.5053 26.7764 45.5329 27.017C46.0088 23.8891 48.7128 21.4899 51.9824 21.4899H51.9755Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4846 28.667L45.3052 27.0446C45.2776 26.7627 45.2569 26.5152 45.2569 26.2884C45.2569 22.6036 48.2644 19.6132 51.9548 19.6132C55.6451 19.6132 58.6526 22.6105 58.6526 26.2884C58.6526 26.5152 58.6388 26.7489 58.6112 26.9896L58.4457 28.5845L58.1905 27.0033C57.6938 23.9373 55.0795 21.7099 51.9617 21.7099C48.8438 21.7099 46.1882 24.0129 45.7191 27.0583L45.4708 28.667H45.4846ZM51.9617 20.0325C48.7887 20.0325 46.1675 22.3905 45.7467 25.4359C46.7745 22.9886 49.2232 21.2837 51.9686 21.2837C54.7139 21.2837 57.1282 22.9198 58.1629 25.3534C57.7076 22.3492 55.1002 20.0394 51.9617 20.0394V20.0325Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7197 31.9667C43.1255 29.2788 43.8429 21.5036 50.0027 20.0737C44.5051 22.2186 43.9808 28.6807 48.7197 31.9667Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6448 26.9483C53.6448 27.9176 52.9067 28.7013 51.9893 28.7013C51.0719 28.7013 50.3338 27.9176 50.3338 26.9483C50.3338 25.979 51.0719 25.1953 51.9893 25.1953C52.9067 25.1953 53.6448 25.979 53.6448 26.9483Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9893 28.9144C50.9615 28.9144 50.1199 28.0345 50.1199 26.9483C50.1199 25.8621 50.9546 24.9822 51.9893 24.9822C53.024 24.9822 53.8586 25.8621 53.8586 26.9483C53.8586 28.0345 53.024 28.9144 51.9893 28.9144ZM51.9893 25.4015C51.196 25.4015 50.5476 26.0959 50.5476 26.9483C50.5476 27.8007 51.196 28.4951 51.9893 28.4951C52.7825 28.4951 53.4309 27.8007 53.4309 26.9483C53.4309 26.0959 52.7825 25.4015 51.9893 25.4015Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.9686 28.007C52.921 28.007 53.693 27.2375 53.693 26.2883C53.693 25.3392 52.921 24.5697 51.9686 24.5697C51.0162 24.5697 50.2441 25.3392 50.2441 26.2883C50.2441 27.2375 51.0162 28.007 51.9686 28.007Z",
    fill: "url(#paint2_linear_6_20236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7988 46.8294C33.3798 46.8294 36.2828 43.9363 36.2828 40.3674C36.2828 36.7984 33.3798 33.9053 29.7988 33.9053C26.2178 33.9053 23.3148 36.7984 23.3148 40.3674C23.3148 43.9363 26.2178 46.8294 29.7988 46.8294Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8057 35.569C33.0615 35.569 35.7517 37.9407 36.2483 41.0411C36.269 40.8142 36.2828 40.5874 36.2828 40.3605C36.2828 36.7926 33.3788 33.8984 29.7988 33.8984C26.2188 33.8984 23.3148 36.7926 23.3148 40.3605C23.3148 40.608 23.3355 40.8555 23.3631 41.0961C23.839 37.9682 26.543 35.569 29.8126 35.569H29.8057Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3217 42.7047L23.1424 41.1235C23.1148 40.8554 23.0941 40.6079 23.0941 40.3673C23.0941 36.6826 26.1016 33.6921 29.7919 33.6921C33.4823 33.6921 36.4897 36.6894 36.4897 40.3673C36.4897 40.5942 36.476 40.8279 36.4484 41.0685L36.2828 42.6634L36.0276 41.0823C35.5309 38.0162 32.9167 35.7889 29.7988 35.7889C26.681 35.7889 24.0184 38.085 23.5562 41.1373L23.3148 42.7116L23.3217 42.7047ZM29.7919 34.1115C26.6258 34.1115 23.9977 36.4626 23.5769 39.508C24.6047 37.0607 27.0535 35.3558 29.7988 35.3558C32.5442 35.3558 34.9584 36.9919 35.9931 39.4186C35.5378 36.4145 32.9304 34.1046 29.7919 34.1046V34.1115Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2343 36.552C38.3384 40.113 36.4553 45.2621 32.1027 46.5751C35.9103 44.499 37.4279 40.4086 35.2343 36.552Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5499 46.0457C20.9557 43.3577 21.6731 35.5826 27.8329 34.1527C22.3353 36.2976 21.8111 42.7597 26.5499 46.0457Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.475 41.0273C31.475 41.9966 30.7369 42.7803 29.8195 42.7803C28.9021 42.7803 28.164 41.9966 28.164 41.0273C28.164 40.058 28.9021 39.2743 29.8195 39.2743C30.7369 39.2743 31.475 40.058 31.475 41.0273Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8195 42.9934C28.7917 42.9934 27.9502 42.1135 27.9502 41.0273C27.9502 39.9411 28.7917 39.0612 29.8195 39.0612C30.8473 39.0612 31.6888 39.9411 31.6888 41.0273C31.6888 42.1135 30.8542 42.9934 29.8195 42.9934ZM29.8195 39.4805C29.0262 39.4805 28.3778 40.1748 28.3778 41.0273C28.3778 41.8797 29.0262 42.5672 29.8195 42.5672C30.6128 42.5672 31.2612 41.8729 31.2612 41.0273C31.2612 40.1817 30.6128 39.4805 29.8195 39.4805Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.0743 40.3673C28.0743 39.4186 28.8469 38.6487 29.7988 38.6487C30.7507 38.6487 31.5233 39.4186 31.5233 40.3673C31.5233 41.316 30.7507 42.086 29.7988 42.086C28.8469 42.086 28.0743 41.316 28.0743 40.3673Z",
    fill: "url(#paint3_linear_6_20236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2997 27.0239C16.2997 23.456 19.2037 20.5618 22.7837 20.5618C26.3637 20.5618 29.2677 23.456 29.2677 27.0239C29.2677 30.5917 26.3637 33.4859 22.7837 33.4859C19.2037 33.4859 16.2997 30.5917 16.2997 27.0239Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7975 22.2255C26.0533 22.2255 28.7434 24.5972 29.2401 27.6976C29.2608 27.4707 29.2746 27.2439 29.2746 27.017C29.2746 23.4491 26.3706 20.5549 22.7906 20.5549C19.2106 20.5549 16.3066 23.4491 16.3066 27.017C16.3066 27.2645 16.3204 27.512 16.3549 27.7526C16.8308 24.6247 19.5348 22.2255 22.8044 22.2255H22.7975Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3204 29.3681L16.141 27.7801C16.1065 27.5051 16.0927 27.2576 16.0927 27.017C16.0927 23.3322 19.1002 20.3418 22.7906 20.3418C26.4809 20.3418 29.4884 23.3391 29.4884 27.017C29.4884 27.2507 29.4746 27.4913 29.4539 27.7182L29.2884 29.3131L29.0332 27.7319C28.5365 24.6659 25.9153 22.4385 22.7975 22.4385C19.6796 22.4385 17.024 24.7415 16.5549 27.7869L16.3135 29.3612L16.3204 29.3681ZM22.7906 20.768C19.6176 20.768 16.9895 23.126 16.5756 26.1714C17.6034 23.7172 20.0521 22.0123 22.8044 22.0123C25.5566 22.0123 27.9571 23.6485 28.9987 26.0752C28.5434 23.071 25.936 20.768 22.7975 20.768H22.7906Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2261 23.2085C31.3301 26.7695 29.447 31.9186 25.0945 33.2316C28.9021 31.1555 30.4196 27.0651 28.2261 23.2085Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5486 32.7023C13.9544 30.0144 14.6718 22.2392 20.8316 20.8093C15.334 22.9542 14.8097 29.4163 19.5486 32.7023Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4668 27.6838C24.4668 28.6531 23.7287 29.4368 22.8113 29.4368C21.8939 29.4368 21.1558 28.6531 21.1558 27.6838C21.1558 26.7145 21.8939 25.9308 22.8113 25.9308C23.7287 25.9308 24.4668 26.7145 24.4668 27.6838Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8113 29.6499C21.7835 29.6499 20.9419 28.77 20.9419 27.6838C20.9419 26.5976 21.7766 25.7177 22.8113 25.7177C23.846 25.7177 24.6806 26.5976 24.6806 27.6838C24.6806 28.77 23.846 29.6499 22.8113 29.6499ZM22.8113 26.137C22.018 26.137 21.3696 26.8313 21.3696 27.6838C21.3696 28.5362 22.018 29.2306 22.8113 29.2306C23.6045 29.2306 24.2529 28.5362 24.2529 27.6838C24.2529 26.8313 23.6045 26.137 22.8113 26.137Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.0661 27.0238C21.0661 26.0751 21.8387 25.3052 22.7906 25.3052C23.7425 25.3052 24.515 26.0751 24.515 27.0238C24.515 27.9725 23.7425 28.7425 22.7906 28.7425C21.8387 28.7425 21.0661 27.9725 21.0661 27.0238Z",
    fill: "url(#paint4_linear_6_20236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6463 16.7877C25.6463 14.196 27.7501 12.0992 30.3506 12.0992C32.9511 12.0992 35.055 14.196 35.055 16.7877C35.055 19.3794 32.9511 21.4761 30.3506 21.4761C27.7501 21.4761 25.6463 19.3794 25.6463 16.7877Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3506 13.3091C32.7097 13.3091 34.6618 15.0277 35.0205 17.2757C35.0343 17.1107 35.0481 16.9457 35.0481 16.7807C35.0481 14.189 32.9442 12.0923 30.3437 12.0923C27.7432 12.0923 25.6394 14.189 25.6394 16.7807C25.6394 16.9595 25.6532 17.1382 25.6739 17.3169C26.0188 15.0483 27.9778 13.3091 30.3506 13.3091Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6394 18.9669L25.46 17.3445C25.4394 17.1658 25.4256 16.9802 25.4256 16.7877C25.4256 14.086 27.6329 11.8861 30.3437 11.8861C33.0546 11.8861 35.2619 14.086 35.2619 16.7877C35.2619 16.9595 35.255 17.1314 35.2343 17.3033L35.0757 18.9257L34.8136 17.3101C34.4618 15.1103 32.5856 13.5223 30.3506 13.5223C28.1157 13.5223 26.2188 15.1653 25.8808 17.3514L25.6325 18.96L25.6394 18.9669ZM30.3506 12.3123C28.2537 12.3123 26.4809 13.756 25.9912 15.7015C26.8258 14.1341 28.4744 13.1029 30.3575 13.1029C32.2407 13.1029 33.8548 14.1135 34.6963 15.6602C34.1928 13.7354 32.4338 12.3123 30.3506 12.3123Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2893 14.024C36.538 16.6089 35.1723 20.3418 32.0199 21.2905C34.7791 19.7849 35.8827 16.822 34.2893 14.024Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9985 20.9124C23.9425 18.9669 24.4668 13.3228 28.9297 12.2848C24.9427 13.8384 24.5633 18.5269 27.9985 20.9124Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5647 17.2689C31.5647 17.9701 31.0266 18.5407 30.3644 18.5407C29.7022 18.5407 29.1642 17.9701 29.1642 17.2689C29.1642 16.5677 29.7022 15.9971 30.3644 15.9971C31.0266 15.9971 31.5647 16.5677 31.5647 17.2689Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3644 18.7537C29.585 18.7537 28.9504 18.0869 28.9504 17.2688C28.9504 16.4508 29.585 15.7839 30.3644 15.7839C31.1439 15.7839 31.7785 16.4508 31.7785 17.2688C31.7785 18.0869 31.1439 18.7537 30.3644 18.7537ZM30.3644 16.2033C29.8195 16.2033 29.378 16.6776 29.378 17.262C29.378 17.8463 29.8195 18.3206 30.3644 18.3206C30.9094 18.3206 31.3508 17.8463 31.3508 17.262C31.3508 16.6776 30.9094 16.2033 30.3644 16.2033Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.0952 16.7876C29.0952 16.1002 29.654 15.5433 30.3437 15.5433C31.0335 15.5433 31.5923 16.1002 31.5923 16.7876C31.5923 17.4751 31.0335 18.0319 30.3437 18.0319C29.654 18.0319 29.0952 17.4751 29.0952 16.7876Z",
    fill: "url(#paint5_linear_6_20236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6559 16.7877C39.6559 14.196 41.7597 12.0992 44.3602 12.0992C46.9607 12.0992 49.0646 14.196 49.0646 16.7877C49.0646 19.3794 46.9607 21.4761 44.3602 21.4761C41.7597 21.4761 39.6559 19.3794 39.6559 16.7877Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3671 13.3091C46.7262 13.3091 48.6783 15.0277 49.037 17.2757C49.0508 17.1107 49.0646 16.9457 49.0646 16.7807C49.0646 14.189 46.9607 12.0923 44.3602 12.0923C41.7597 12.0923 39.6559 14.189 39.6559 16.7807C39.6559 16.9595 39.6697 17.1382 39.6904 17.3169C40.0353 15.0483 41.9943 13.3091 44.3671 13.3091Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6559 18.9669L39.4765 17.3445C39.4558 17.1658 39.442 16.9802 39.442 16.7877C39.442 14.086 41.6494 11.8861 44.3602 11.8861C47.0711 11.8861 49.2784 14.086 49.2784 16.7877C49.2784 16.9595 49.2646 17.1314 49.2508 17.3033L49.0922 18.9257L48.83 17.3101C48.4783 15.1103 46.602 13.5223 44.3671 13.5223C42.1322 13.5223 40.2353 15.1653 39.8973 17.3514L39.649 18.96L39.6559 18.9669ZM44.3671 12.3123C42.2702 12.3123 40.4974 13.756 40.0077 15.7015C40.8423 14.1341 42.4909 13.1029 44.374 13.1029C46.2571 13.1029 47.8712 14.1135 48.7128 15.6602C48.2092 13.7354 46.4503 12.3123 44.3671 12.3123Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3058 14.024C50.5545 16.6089 49.1887 20.3418 46.0364 21.2905C48.7956 19.7849 49.8992 16.822 48.3058 14.024Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.008 20.9124C37.9521 18.9669 38.4763 13.3228 42.9393 12.2848C38.9523 13.8384 38.5729 18.5269 42.008 20.9124Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5811 17.2689C45.5811 17.9701 45.0431 18.5407 44.3809 18.5407C43.7187 18.5407 43.1807 17.9701 43.1807 17.2689C43.1807 16.5677 43.7187 15.9971 44.3809 15.9971C45.0431 15.9971 45.5811 16.5677 45.5811 17.2689Z",
    fill: "#0D1214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3809 18.7537C43.6015 18.7537 42.9669 18.0869 42.9669 17.2688C42.9669 16.4508 43.6015 15.7839 44.3809 15.7839C45.1604 15.7839 45.795 16.4508 45.795 17.2688C45.795 18.0869 45.1604 18.7537 44.3809 18.7537ZM44.3809 16.2033C43.836 16.2033 43.3945 16.6776 43.3945 17.262C43.3945 17.8463 43.836 18.3206 44.3809 18.3206C44.9258 18.3206 45.3673 17.8463 45.3673 17.262C45.3673 16.6776 44.9258 16.2033 44.3809 16.2033Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.1117 16.7876C43.1117 16.1002 43.6704 15.5433 44.3602 15.5433C45.05 15.5433 45.6087 16.1002 45.6087 16.7876C45.6087 17.4751 45.05 18.0319 44.3602 18.0319C43.6704 18.0319 43.1117 17.4751 43.1117 16.7876Z",
    fill: "url(#paint6_linear_6_20236)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3131 59.6299H22.6319C16.1251 59.6299 10.8504 64.8868 10.8504 71.3716V72.8015C10.8504 79.2863 16.1251 84.5433 22.6319 84.5433H50.3131C56.8199 84.5433 62.0947 79.2863 62.0947 72.8015V71.3716C62.0947 64.8868 56.8199 59.6299 50.3131 59.6299Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.8027 59.1074H23.3286C16.9856 59.1074 11.8437 64.232 11.8437 70.5536V71.9491C11.8437 78.2706 16.9856 83.3952 23.3286 83.3952H49.8027C56.1456 83.3952 61.2876 78.2706 61.2876 71.9491V70.5536C61.2876 64.232 56.1456 59.1074 49.8027 59.1074Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3288 80.8311C29.5746 80.8311 33.8272 76.7345 33.8272 71.681C33.8272 66.6276 29.5746 62.531 24.3288 62.531C19.083 62.531 14.8304 66.6276 14.8304 71.681C14.8304 76.7345 19.083 80.8311 24.3288 80.8311Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1016 71.9697C26.1016 73.2896 25.129 74.3552 23.9218 74.3552C22.7147 74.3552 21.7421 73.2896 21.7421 71.9697C21.7421 70.6498 22.7147 69.5842 23.9218 69.5842C25.129 69.5842 26.1016 70.6498 26.1016 71.9697Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.2251 71.681C59.2251 76.7338 54.9691 80.8311 49.7268 80.8311C44.4844 80.8311 40.2284 76.7338 40.2284 71.681C40.2284 66.6282 44.4844 62.531 49.7268 62.531C54.9691 62.531 59.2251 66.6282 59.2251 71.681Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6306 71.9697C51.6306 73.2896 50.658 74.3552 49.4509 74.3552C48.2437 74.3552 47.2711 73.2896 47.2711 71.9697C47.2711 70.6498 48.2437 69.5842 49.4509 69.5842C50.658 69.5842 51.6306 70.6498 51.6306 71.9697Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.5085 71.681C26.5085 72.8359 25.5359 73.7777 24.3288 73.7777C23.1217 73.7777 22.1491 72.8359 22.1491 71.681C22.1491 70.526 23.1217 69.5842 24.3288 69.5842C25.5359 69.5842 26.5085 70.526 26.5085 71.681Z",
    fill: "url(#paint7_linear_6_20236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7268 73.7777C50.9306 73.7777 51.9065 72.839 51.9065 71.681C51.9065 70.523 50.9306 69.5842 49.7268 69.5842C48.5229 69.5842 47.547 70.523 47.547 71.681C47.547 72.839 48.5229 73.7777 49.7268 73.7777Z",
    fill: "url(#paint8_linear_6_20236)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6923 77.5588C10.3399 71.7635 11.7126 63.4797 17.7689 60.2899C19.7417 59.1968 23.101 59.3687 25.2807 59.3343C29.6471 59.2381 33.9927 59.2931 38.3453 59.403C42.6909 59.5337 47.0366 59.6987 51.3754 60.008C42.6978 60.283 33.9858 60.1799 25.3221 60.3655C13.8302 60.6198 10.0088 69.6255 13.6923 77.5656V77.5588Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2874 67.2606C62.074 72.1278 60.8599 78.583 56.3625 81.6422C51.5271 84.2889 45.3949 82.9896 40.0973 83.1821C36.5794 83.1615 33.0615 83.1271 29.5436 82.969C33.0546 82.6803 51.1615 83.0927 55.7279 80.8379C60.1288 77.9849 61.5014 72.2172 60.2874 67.2606Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0651 54.3021C52.3756 55.512 53.6792 56.1308 54.7967 56.7082C60.8323 59.8018 66.0264 66.0645 66.5162 72.8084C68.6752 68.7593 68.2751 64.0021 67.1301 59.5612C66.4817 57.052 65.2608 54.639 63.3363 52.8997C61.5773 51.3117 58.9285 50.1636 56.5143 50.4455C54.6863 50.6586 51.4512 51.951 52.0582 54.309L52.0651 54.3021Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.7651 22.8648C70.0272 17.2826 66.5921 7.80948 57.8663 2.58482C54.1138 0.33684 46.1813 0.364338 46.1813 0.364338H27.8191C17.8448 -0.0137627 3.69036 3.73975 3.13853 27.3057L3.19372 73.7502C3.19372 84.1996 11.3953 91.9128 21.8801 91.9128H50.9615C61.4463 91.9128 69.7996 82.859 69.7927 72.0866L69.7582 22.8648H69.7651ZM66.5231 72.8084C66.5231 81.5804 59.3907 88.6886 50.589 88.6886H22.6733C13.6509 88.6886 7.24967 81.9791 6.33225 72.7397V71.1998C6.33225 63.954 11.2021 57.5263 17.8586 55.6152C18.9623 55.2989 19.721 54.2815 19.721 53.1403V52.7072C19.721 51.9166 19.3692 51.1673 18.7415 50.6861C11.6781 45.3033 7.08412 36.8889 6.95996 27.5601C6.88408 21.8336 8.42231 16.5127 11.1401 11.9823C14.2372 6.81267 19.9349 3.73975 25.9774 3.73975H46.6641C53.7896 3.73975 60.3495 7.72699 63.488 14.0928C65.585 18.3551 66.6886 23.1879 66.4886 28.2682C66.1644 36.6826 61.4463 44.6502 55.4589 49.9024C54.5829 50.6723 54.0655 51.7723 54.0655 52.9409V53.0441C54.0655 54.3159 54.8105 55.4708 55.9762 55.9795C61.7498 58.4956 66.5162 64.3665 66.5162 70.8629V72.8015L66.5231 72.8084Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8517 55.6152C19.2244 55.1683 19.7969 53.6903 19.521 52.3704C19.3209 50.9473 17.8172 50.418 16.8998 49.5106C11.6091 45.0283 7.99463 38.5594 7.1462 31.678C6.97375 30.3099 6.92546 28.9281 6.95995 27.5532C7.08412 29.2512 7.32554 30.963 7.67043 32.6266C9.0707 38.9375 12.4576 44.7602 17.2516 49.1118C18.2035 50.0949 19.7486 50.7961 19.859 52.3222C20.0452 53.7315 19.3347 55.3127 17.8586 55.6152H17.8517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5231 72.8085C66.7093 79.4287 62.3154 85.7945 56.0452 87.9944C52.9481 89.2386 49.5543 88.9637 46.2985 89.0049L36.5242 89.0393L26.75 89.0118C23.4942 88.9774 20.0935 89.2249 17.0033 87.9875C10.6227 85.7532 6.76681 79.2568 6.32535 72.7466C7.02893 79.0849 10.9055 85.4233 17.1826 87.4856C20.2039 88.6474 23.4942 88.3518 26.75 88.3793L36.5242 88.3518L46.2985 88.3862C49.5198 88.3656 52.8032 88.6543 55.8728 87.5063C62.0671 85.4508 66.4265 79.3049 66.5231 72.8153V72.8085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4811 14.0997C69.9306 26.1165 66.5438 39.9549 56.735 49.0294L55.6313 50.0124C53.7137 51.4836 53.5896 54.8865 55.9762 55.9864C53.4033 55.0171 53.3964 51.3255 55.3761 49.7237L56.4315 48.72C65.8471 39.3569 69.0339 26.3846 63.4811 14.0997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7651 22.8648C69.6685 14.8422 64.8193 7.19767 58.0663 3.03169C54.6381 1.02432 50.389 0.84558 46.4848 0.680591L34.3859 0.708089C30.8611 0.797458 25.7843 0.433107 22.3422 0.948698C18.4035 1.48491 14.5476 2.97669 11.5195 5.5684C5.28377 10.8481 3.48343 19.4894 3.13853 27.3057C3.20062 19.3725 4.90439 10.6418 11.1746 5.15593C14.2372 2.41985 18.238 0.900577 22.2525 0.316239C25.7498 -0.226851 30.8197 0.110003 34.3859 0.0137587L46.4917 0.0481315C50.52 0.247494 54.7967 0.419357 58.3422 2.57797C65.1297 6.90206 69.9513 14.7391 69.7582 22.8579L69.7651 22.8648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19372 73.7503C3.35237 84.0346 11.6298 91.6654 21.8387 91.6104C22.6802 91.6104 25.1083 91.6104 25.9912 91.6035C32.8339 91.5622 44.0843 91.5829 50.9063 91.6104C53.6241 91.5829 56.3556 91.0054 58.7975 89.7955C65.0263 86.8325 69.1857 80.2674 69.703 73.4684L69.7927 72.0935C69.9582 79.4974 65.7712 86.9563 59.032 90.2767C56.5419 91.576 53.7069 92.1878 50.9063 92.2291C44.0912 92.2635 32.8201 92.2703 25.9912 92.236C25.1359 92.236 22.6802 92.2359 21.8387 92.2222C11.485 92.2291 2.9523 84.234 3.19372 73.7571V73.7503Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_20236",
    x1: 37.3658,
    y1: 28.6737,
    x2: 37.3658,
    y2: 25.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_20236",
    x1: 44.9603,
    y1: 41.3435,
    x2: 44.9603,
    y2: 37.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_20236",
    x1: 51.9617,
    y1: 28.0001,
    x2: 51.9617,
    y2: 24.5697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_20236",
    x1: 29.7988,
    y1: 42.0791,
    x2: 29.7988,
    y2: 38.6487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_20236",
    x1: 22.7906,
    y1: 28.7356,
    x2: 22.7906,
    y2: 25.3052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_20236",
    x1: 30.3506,
    y1: 18.0319,
    x2: 30.3506,
    y2: 15.5433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_20236",
    x1: 44.3602,
    y1: 18.0319,
    x2: 44.3602,
    y2: 15.5433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_20236",
    x1: 24.3288,
    y1: 73.7777,
    x2: 24.3288,
    y2: 69.5842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_20236",
    x1: 49.7268,
    y1: 73.7777,
    x2: 49.7268,
    y2: 69.5842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_20236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs2Socket);
export default __webpack_public_path__ + "static/media/ccs2_socket.54f25b996bb52d170fa9fd35190dd88a.svg";
export { ForwardRef as ReactComponent };